interface AvatarProps {
  name: string
  colors: [string, string]
  size?: number
}

export function Avatar({ name, colors, size = 40 }: AvatarProps) {
  const initials = name
    .split(' ')
    .slice(0, 2)
    .map((p) => p[0]?.toUpperCase() ?? '')
    .join('')

  return (
    <div
      className="flex shrink-0 items-center justify-center rounded-2xl font-semibold text-white shadow-sm"
      style={{
        width: size,
        height: size,
        fontSize: size * 0.38,
        backgroundImage: `linear-gradient(135deg, ${colors[0]}, ${colors[1]})`,
      }}
    >
      {initials}
    </div>
  )
}
